import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { InputFieldWrapper, Switch, SwitchInput, Icon, SwitchLabel } from './styles';

const SwitchToggle = ({
  id,
  name,
  text,
  defaultChecked,
  value = 1,
  onChange,
  tabIndex = 0,
  lightMode = false,
  disabled = false,
  children,
  ...rest
}) => {
  const switchToggleRef = useRef(null);
  const triggerClick = useCallback(() => {
    switchToggleRef.current.click();
  });
  const onChangeHandler = (ev) => {
    ev.target.parentNode.blur();
    onChange(ev);
  };

  return (
    <InputFieldWrapper>
      <Switch
        tabIndex={tabIndex}
        onKeyDown={triggerClick}
        htmlFor={id || name}
        lightMode={lightMode}
        disabled={disabled}
      >
        <SwitchInput
          ref={switchToggleRef}
          key={`${id}_${defaultChecked}`}
          type="checkbox"
          name={name || id}
          id={id || name}
          defaultChecked={defaultChecked}
          value={value}
          onChange={onChangeHandler}
          disabled={disabled}
          {...rest}
        />
        <Icon htmlFor={id || name} onClick={triggerClick} />
        <SwitchLabel onClick={triggerClick}>{children}</SwitchLabel>
      </Switch>
    </InputFieldWrapper>
  );
};

SwitchToggle.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  defaultChecked: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  children: PropTypes.string,
  lightMode: PropTypes.bool,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  rest: PropTypes.object,
};

export default SwitchToggle;
